"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaximumInputLength = void 0;
var MaximumInputLength = function (target) {
    return /** @class */ (function (_super) {
        __extends(MaximumInputLength, _super);
        function MaximumInputLength() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MaximumInputLength.prototype.query = function (params, callback) {
            this.maximumInputLength = this.options.get('maximumInputLength');
            params.term = params.term || '';
            if (this.maximumInputLength > 0 && params.term.length > this.maximumInputLength) {
                this.trigger('results:message', {
                    message: 'inputTooLong',
                    args: {
                        maximum: this.maximumInputLength,
                        input: params.term,
                        params: params
                    }
                });
                return;
            }
            _super.prototype.query.call(this, params, callback);
        };
        return MaximumInputLength;
    }(target));
};
exports.MaximumInputLength = MaximumInputLength;
//# sourceMappingURL=maximum-input-length.js.map